
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";


const Outline = styled.div`
  margin-left: 10px;

  & > div {
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background-color: var(--sidebar-hover-item-bg);
    }
  }
`;

const EditCourseLevelSidebarWrapper = styled.div`
  width: 300px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;
  z-index: 1;

  height: auto;
  position:sticky;
`;

const EditCourseLevelSidebarInnerWrapper = styled.div`
  width: 300px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const EditCourseLevelSidebarItems = styled.div`
  margin-top: 20px;
`;

const EditCourseLevelSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const EditCourseLevelSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const EditCourseLevelSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const EditCourseLevelSidebar = ({
  show = true,
  courseLevel = null,
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
  onToggle = () => { },
}) => {
  console.log("!!! DEFAULT SELECTED TAB: ", defaultSelectedTab)
  const navigate = useNavigate();
  const [showOutline, setShowOutline] = useState(true);
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);

    // eslint-disable-next-line
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab === tab ? "active" : "";
  }


  return (
    <EditCourseLevelSidebarWrapper
      style={{
        width: show ? "300px" : "24px",
        transition: "width 0.3s ease-in-out",
        height: "100vh",
        marginTop: "-20px",
      }}
    >
      <button
        onClick={() => {
          onToggle();
        }}
        style={{
          width: "24px",
          height: "40px",
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
          borderTopRightRadius: ".25rem",
          borderBottomRightRadius: ".25rem",
          outline: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          right: "-24px",
          zIndex: 1,
          border: "none",
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <EditCourseLevelSidebarInnerWrapper
        style={{ display: show ? "flex" : "none" }}
      >
        <EditCourseLevelSidebarItems style={{ flexGrow: 0 }}>
          <EditCourseLevelSidebarItem className={isSelected("details")} onClick={() => selectTab("details")}>
            <span>
              <EditCourseLevelSidebarItemIcon icon="lucide:info" />
            </span>
            <EditCourseLevelSidebarItemText>Details</EditCourseLevelSidebarItemText>
          </EditCourseLevelSidebarItem>
          <EditCourseLevelSidebarItem className={isSelected("levels")} onClick={() => selectTab("levels")}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <span>
                  <EditCourseLevelSidebarItemIcon icon="material-symbols:list" />
                </span>
                <EditCourseLevelSidebarItemText>Sections</EditCourseLevelSidebarItemText>
                <span onClick={(e) => {
                  e.stopPropagation();
                  setShowOutline(!showOutline);
                }}>
                  {showOutline ? (
                    <EditCourseLevelSidebarItemIcon icon="lucide:chevron-down" style={{ fontSize: "16px", marginLeft: "10px" }} />
                  ) : (
                    <EditCourseLevelSidebarItemIcon icon="lucide:chevron-right" style={{ fontSize: "16px", marginLeft: "10px" }} />
                  )}
                </span>
              </div>
            </div>
          </EditCourseLevelSidebarItem>
          <Outline
            style={{ height: showOutline ? "auto" : "0px", overflow: "hidden", transition: "height 0.3s ease-in-out" }}
          >
            {courseLevel.sections.map((section, index) => {
              return (
                <div key={index} style={{
                  fontSize: "13px",
                  padding: "3px 10px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                  onClick={() => {
                    navigate(`/levelsection/${section.public_id}`)
                  }}
                >{section.section_number}. {section.title}</div>
              );
            })}
          </Outline>

        </EditCourseLevelSidebarItems>
      </EditCourseLevelSidebarInnerWrapper>
    </EditCourseLevelSidebarWrapper>
  );
};

export default EditCourseLevelSidebar;
